import React from "react";
import IcConfrimPopupSuccess from "../../assets/svg/IcConfrimPopupSuccess.svg";
import { 
    PopoverContentContainer,
    PopoverContentCenterIcon,
    PopoverContentBodyText,
    PopoverContentBottomButton,
    PopoverContentBottomButtonWrapper,
    PopoverContentBottomWrapper
 } from "./ConfirmMyDocAccept.style";

function SuccessMyDocAccept({ onClikcConfirmButton }) {
    const handleConfirmButton = () => {
        onClikcConfirmButton();
      };

    return (
        <>
          <PopoverContentContainer>
            <PopoverContentCenterIcon  src={IcConfrimPopupSuccess}/>
            <PopoverContentBodyText>
                사건 서류에 대한 최종 승인이 완료되었습니다.
            </PopoverContentBodyText>
            <PopoverContentBottomWrapper>
                <PopoverContentBottomButtonWrapper isConfirm={true} onClick={handleConfirmButton}>
                    <PopoverContentBottomButton>확인</PopoverContentBottomButton>
                </PopoverContentBottomButtonWrapper>
            </PopoverContentBottomWrapper>
          </PopoverContentContainer>
        </>
    );
}

export default SuccessMyDocAccept;